import { useApp } from 'App';
import { Container, Box, Title } from './Styles';
import { Offer, DailyBonus } from 'components';
import offerBlue from 'assets/offer/backgrounds/offer_blue.jpg';
import offerPurple from 'assets/offer/backgrounds/offer_purple.jpg';
import offerRed from 'assets/offer/backgrounds/offer_red.jpg';
import { Fragment, useEffect, useState } from 'react';
import storeService from 'components/Store/store.service';

const Offers = () => {
  const { state } = useApp();
  const { store, storeType, storeEvent, dailyBonusTime } = state;
  const isBuyPage = storeType === 'BP';

  const { evs, bPe } = store;
  const { pks } = bPe;

  const [offers, setOffers] = useState([]);
  const [dailyBonus, setDailyBonus] = useState();
  const isAscending = pks.at(0).cot < pks.at(-1).cot;

  useEffect(() => {
    const { offers, dailyBonus } = storeService.getOffers({ event: storeEvent, data: evs });
    setOffers(offers);
    setDailyBonus(dailyBonus);
  }, [store]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [storeType]);

  const renderDailyBonus = () =>
    (dailyBonus || dailyBonusTime) && (
      <Container>
        <Title>Free Daily bonus</Title>
        <Box>
          <DailyBonus background={offerRed} dailyBonus={dailyBonus} />
        </Box>
      </Container>
    );

  return isBuyPage ? (
    <Fragment>
      <Container $offersLength={pks.length}>
        <Title>Daily offers</Title>
        <Box>
          {pks.map((offer, index, { length }) => (
            <Offer
              key={index}
              offer={{ ...offer, assetKey: `regular${isAscending ? index + 1 : length - index}` }}
              background={offerPurple}
              offersLength={length}
            />
          ))}
        </Box>
      </Container>
      {renderDailyBonus()}
    </Fragment>
  ) : (
    Object.values(offers).map(({ data, title }, index) => (
      <Fragment key={index}>
        <Container $offersLength={data.length}>
          <Title>{title}</Title>
          <Box>
            {data.map((offer, i) => (
              <Offer
                key={`${offer.izid}-${i}`}
                offer={offer}
                background={offerBlue}
                offersLength={data.length}
              />
            ))}
          </Box>
        </Container>
        {index === 0 && renderDailyBonus()}
      </Fragment>
    ))
  );
};

export default Offers;
